import Button from "@/components/base/Button";
import { SHOP_URL } from "@/pages/home/constants";
import { withUtm } from "@/utils/shopUrl";

export default function Shipping() {
  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-content px-4 pb-16 md:px-6 md:pb-24">
        <div className="reveal overflow-hidden rounded-2xl bg-primary-50 ring-1 ring-primary-200">
          <img
            src="https://readdy.ai/api/search-image?query=Natural%20light%20wood%20texture%20close%20up%20with%20warm%20grain%20and%20soft%20natural%20lighting%2C%20minimal%20artisanal%20detail%2C%20warm%20neutral%20tones%2C%20editorial%20macro%20photography&width=1600&height=200&seq=iokus-wood-texture&orientation=landscape"
            alt="Detalle de la textura de la madera usada en los juegos de Iokus"
            title="Madera reforestada Iokus"
            loading="lazy"
            className="h-2.5 w-full object-cover md:h-3"
          />
          <div className="px-6 py-12 text-center md:px-10 md:py-16">
            <h2 className="text-2xl font-semibold md:text-[34px]">¿No alcanzas a venir a Guatapé?</h2>
            <p className="mx-auto mt-4 max-w-xl text-base text-foreground-700 md:text-lg">
              Te lo enviamos a donde estés. Envío gratis por compras superiores a $300.000.
            </p>
            <div className="mt-8 flex justify-center">
              <Button
                href={withUtm(SHOP_URL)}
                variant="primary"
                external
                fbEvent="ClicTiendaOnline"
                fbLabel="generico"
                className="px-7 py-3 text-base"
              >
                Ir a la tienda online
                <i className="ri-arrow-right-up-line text-base" aria-hidden="true"></i>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}